import { render, staticRenderFns } from "./liveVideo.vue?vue&type=template&id=008e2efd&scoped=true"
import script from "./liveVideo.vue?vue&type=script&lang=js"
export * from "./liveVideo.vue?vue&type=script&lang=js"
import style0 from "./liveVideo.vue?vue&type=style&index=0&id=008e2efd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e2efd",
  null
  
)

export default component.exports